export default __webpack_public_path__ + "static/media/logoWhiteFR.c98e14c8.png";